import { Inject, Injectable, NgZone } from '@angular/core';
import { LOCAL_STORAGE, StorageService } from 'ngx-webstorage-service';
import { Observable, Subject } from 'rxjs';
import { WindowService } from './window.service';

@Injectable({
  providedIn: 'root',
})
export class CrossTabsEventsService {
  private readonly eventidChanged$ = new Subject<string>();
  private readonly tradingSessionStateUpdatedInDifferentTab$ = new Subject<string>();
  private readonly logoutInDifferentTab$ = new Subject<{
    loggedout: boolean;
    userchanged: boolean;
  }>();

  constructor(
    private windowService: WindowService,
    private ngZone: NgZone,
    @Inject(LOCAL_STORAGE) private localStorage: StorageService,
  ) {
    this.ngZone.runOutsideAngular(() => {
      this.windowService.getWindow().addEventListener('storage', (ev: StorageEvent) => {
        if (ev.key === 'activeSession') {
          this.ngZone.run(() => {
            this.eventidChanged$.next(ev.newValue);
          });
        }
        if (ev.key === 'tradingSessionStateUpdated') {
          this.ngZone.run(() => {
            this.tradingSessionStateUpdatedInDifferentTab$.next(ev.newValue);
          });
        }
        if (ev.key.startsWith('CognitoIdentityServiceProvider.') && ev.key.endsWith('.LastAuthUser')) {
          const ret = { loggedout: false, userchanged: false };
          if (!ev.newValue) {
            ret.loggedout = true;
          } else if (ev.newValue && ev.oldValue) {
            ret.userchanged = true;
          }
          if (ret.loggedout || ret.userchanged) {
            this.ngZone.run(() => {
              this.logoutInDifferentTab$.next(ret);
            });
          }
        }
      });
    });
  }

  public getEventIdChange$(): Observable<string> {
    return this.eventidChanged$.asObservable();
  }

  public getTradingSessionStateUpdatedInDifferentTab$(): Observable<string> {
    return this.tradingSessionStateUpdatedInDifferentTab$.asObservable();
  }

  public triggerTradingSessionStateUpdatedInDifferentTab(): void {
    this.localStorage.set('tradingSessionStateUpdated', new Date().toISOString());
  }

  public getLogoutInDifferentTab(): Observable<{
    loggedout: boolean;
    userchanged: boolean;
  }> {
    return this.logoutInDifferentTab$.asObservable();
  }
}
